import { useTranslation } from "react-i18next";
import IPartner from "../../../models/partner/IPartner";
import { Button, Image, Link, makeStyles, Title2 } from "@fluentui/react-components";
import { Open16Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
    root: {
        display: "block",
        width: "100%",

        "@media (min-width: 600px)": {
            maxWidth: "1200px",
            margin: "0 auto",
        }
    },
    partner: {
        display: "flex",
        alignItems: "center", // Vertically align image and text
        width: "100%",
        height: "fit-content",

        "@media (max-width: 600px)": {
            flexDirection: "column",
            alignItems: "stretch",

            "&:not(:first-of-type)": {
                borderTop: "4px solid #fff7eb",
            }
        },
    },
    partnerReverse: {
        flexDirection: "row-reverse", // Reverse layout for alternating partners
        "@media (max-width: 600px)": {
            flexDirection: "column"
        }
    },
    partnerLogo: {
        padding: "16px",
        maxWidth: "350px",
        width: "100%",
        textAlign: "center", // Center the image horizontally

        "@media (max-width: 600px)": {
            maxWidth: "100%",
            paddingBottom: 0
        },

        "& img": {
            margin: "auto",
            width: "100%",
            height: "auto",
            maxHeight: "350px",
            maxWidth: "500px",
            objectFit: "contain"
        }
    },
    partnerDetails: {
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // Center text vertically
        flex: 1 // Take up remaining space
    },
});

export default function FeaturedPartner(props: { partner: IPartner, index: number }) {
    const { t } = useTranslation("partners");
    const { partner, index } = props;

    const styles = useStyles();

    return (
        <div className={styles.root}>
            <div className={styles.partner}>
                <div className={styles.partnerLogo}>
                    <Image
                        src={partner.darkImage?.url || partner.image.url}
                        alt={partner.darkImage?.altText || partner.image.altText}
                        />
                </div>
                <div className={styles.partnerDetails}>
                    <Title2 block as="h2">
                        {partner.name}
                    </Title2>
                    
                    <div dangerouslySetInnerHTML={{ __html: partner.description }} />
                    
                    <Link as="a" href={partner.url} target="_blank">
                        <Button appearance="secondary" icon={<Open16Regular />}>
                            {t("visitWebsite")}
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
}